import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedMethodsSection } from './components/FailedMethodsSection';
import { UniqueMechanismSection } from './components/UniqueMechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
import { SalesNotification } from './components/SalesNotification';
import { useFacebookPixel } from './hooks/useFacebookPixel';
export function App() {
  useFacebookPixel();
  return <main className="min-h-screen w-full bg-slate-900 text-slate-100 overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedMethodsSection data-id="element-4" />
      <UniqueMechanismSection data-id="element-5" />
      <WhatYouGetSection data-id="element-6" />
      <WhoIsForSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <FooterSection data-id="element-12" />
      <SalesNotification data-id="element-13" />
    </main>;
}